import React from "react"

import { FormControl, FormLabel } from "@mui/joy";
import { Controller } from "react-hook-form";
import { List } from "src/mtska-frontend-modules/modules/AudienceLead/views";
import { useTranslation } from 'react-i18next';
import { useListFiltersAdapter } from "src/mtska-frontend-app-component/utils";
import JSONPretty from 'react-json-pretty';

const InputListAudienceLead = ({
    control,
    editing,
    name,
    label,
    readonly,
    className = "",
    dataProviderName,
    defaultSelectedValues,
    enableSelection,
    disableMultipleRowSelection,
    hideTableToolbar = false,
    filters,
    relation
}) => {

    const { adaptRelationshipFilters } = useListFiltersAdapter();
    const { t } = useTranslation();
    if (!editing) readonly = true;

    let generalClass = "form-element-control";
    generalClass += (editing) ? " editing" : " reading";
    generalClass += (readonly) ? " readonly" : "";
    if (relation.otherFilters === undefined) {
        return
    }
    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, value, name },
                fieldState: { error, invalid },
                formState,
            }) => {

                const rowSelectionExternalListener = (selectionModel) => {
                    onChange(selectionModel);
                }

                return (
                    ((relation?.otherFilters?.segments ?? []).length > 0 || relation?.otherFilters?.campaign) && <div className={("form-element list " + className).trim()}>
                        <FormControl error={invalid} className={(error) ? generalClass + " form-element-error" : generalClass}>
                            <FormLabel className="form-element-label" htmlFor={name}>{t(label)}</FormLabel>
                            {/* <JSONPretty data={relation} className="json-wrapper"/> */}
                            <List
                                leftButtons={[]}
                                rightButtons={[relation.externalButtons]}
                                dataProviderName={dataProviderName}
                                title={label}
                                rowSelectionExternalListener={rowSelectionExternalListener}

                                //defaultSelectedValues={defaultSelectedValues}
                                enableSelection={enableSelection}
                                disableMultipleRowSelection={disableMultipleRowSelection}

                                className={className}
                                hideTableToolbar={true}
                                hideTableFooter={false}
                                isEmbedded={true}
                                otherFilters={relation.otherFilters}
                                externalButtons={relation.externalButtons ?? null}
                                selectionModel={relation.selectionModel ?? []}
                            />
                        </FormControl>
                    </div>
                )
            }}
        />
    );
};


export default InputListAudienceLead;